import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { aiAgentKnowledgeBaseQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/queries/queryKeyFactory";
import type { KnowledgeBaseResponse } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/types";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useGetCustomization = (): UseQueryResult<KnowledgeBaseResponse> => {
    return useQuery({
        queryKey: aiAgentKnowledgeBaseQueryKeys.customization(),
        queryFn: async ({ signal }) => {
            return await salesApiService.aiAgent.knowledgeBase.getCustomization({ cancellation: signal });
        },
    });
};
